import * as React from 'react'
import Header from './Header'
import Footer from './Footer'
import { Container, CssBaseline } from '@mui/material'
import "./Home.css"
import { CurrentUserProvider } from './CurrentUserContext'
import PropTypes from 'prop-types'
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { createTheme, ThemeProvider } from '@mui/material/styles'
import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'
import HeroView from './HeroView'
import About from './About'
import Contact from './Contact'

const theme = createTheme({
  // cssVariables: true,
  cssVariables: {colorSchemeSelector: 'class'},
  colorSchemes: {
    light: true,
    dark: true,
  },
})

const Index = (props) => {
  console.log(props)
  // const { classes } = props
  // const classes = useStyles(); // Call the useStyles function to get the styles

  React.useEffect(() => {
    console.log('RENDERING INDEX')
  }, [])

  return (
    <BrowserRouter>
      <InitColorSchemeScript modeStorageKey="theme-mode" attribute="class" />
      <ThemeProvider theme={theme} modeStorageKey='theme-mode'>
        {/* <div className="home"> */}
          <CurrentUserProvider userData={props.currentUser}>
              <CssBaseline />
              <Header />
              <Container className="main">
                <Routes>
                  <Route path="/" element={<HeroView />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                </Routes>
              </Container>
              <Footer />
          </CurrentUserProvider>

        {/* </div> */}
      </ThemeProvider>
    </BrowserRouter>
  )
}


Index.propTypes = {
  currentUser: PropTypes.object,
}


export default Index
